export default __webpack_public_path__ + "static/media/23.d072e6e1.pdf";